import React from 'react';
import './hme-expand-collapse.css';

const HMEExpandCollapse = (props) => {
  const { isExpanded, onClick } = props;

  return (
    <React.Fragment>
      <button
        id="hme-expand-normal"
        className={`${isExpanded ? 'hme-expand-expanded' : 'hme-expand-collapsed'} hme-expand-normal`}
        onClick={onClick}
        tabIndex="0"
      >
        {!isExpanded ?
          (<i className="td-icon icon-ui-plus" />)
          :
          (<i className="td-icon icon-round-cross" />)
        }
      </button>
    </React.Fragment>
  );
};

export default HMEExpandCollapse;
